/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { ListCompositionsListQueryResponse, ListCompositionsListQueryParams } from "../models/ListCompositionsList";

export function getListCompositionsListUrl() {
  const res = { method: 'GET', url: `/compositions` as const }
  return res
}

/**
 * @summary List compositions for a station (creator, edit previews; optional start/end on createdAt; optional name LIKE filter)
 * {@link /compositions}
 */
export async function listCompositionsList(params: ListCompositionsListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListCompositionsListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListCompositionsListUrl().url.toString(), params, ... requestConfig })
  return res.data
}